
const appConfig = {
  APP_URL: "https://login.tressrevolution.com/Revolution",
  API_URL: "https://login.tressrevolution.com/RevolutionAPI",
  APP_VERSION: "MAIN-006b5",
};

export default appConfig;